export function compareDateWithCurrentTime(inputDate: string) {
  // const utcDate = new Date(inputDate);
  // const localOffsetMinutes = utcDate.getTimezoneOffset();
  // const localInputDate = new Date(utcDate.setMinutes(utcDate.getMinutes() - localOffsetMinutes));

  //const offsetMinutes = new Date().getTimezoneOffset();
  const currentDate = new Date();
  // const targetDate = new Date(
  //   new Date(localInputDate).getTime() - offsetMinutes * 60 * 1000,
  // );
  const targetDate = new Date(inputDate);

  if (isNaN(targetDate.getTime())) {
    return 'Н/д';
  }

  if (targetDate < currentDate) {
    return 'Не актуально';
  } else {
    const timeDifference = targetDate.getTime() - currentDate.getTime();

    const years = targetDate.getUTCFullYear() - currentDate.getUTCFullYear();
    const months = targetDate.getUTCMonth() - currentDate.getUTCMonth();
    const days = targetDate.getUTCDate() - currentDate.getUTCDate();
    const hours = targetDate.getUTCHours() - currentDate.getUTCHours();
    const minutes = targetDate.getUTCMinutes() - currentDate.getUTCMinutes();
    const seconds = targetDate.getUTCSeconds() - currentDate.getUTCSeconds();

    let remainingMonths = months;
    let remainingDays = days;
    let remainingHours = hours;
    let remainingMinutes = minutes;
    let remainingSeconds = seconds;

    if (remainingSeconds < 0) {
      remainingSeconds += 60;
      remainingMinutes -= 1;
    }

    if (remainingMinutes < 0) {
      remainingMinutes += 60;
      remainingHours -= 1;
    }

    if (remainingHours < 0) {
      remainingHours += 24;
      remainingDays -= 1;
    }

    if (remainingDays < 0) {
      const lastMonthDate = new Date(
        targetDate.getFullYear(),
        targetDate.getMonth(),
        0,
      );
      remainingDays += lastMonthDate.getDate();
      remainingMonths -= 1;
    }

    if (remainingMonths < 0) {
      remainingMonths += 12;
    }

    if (years > 0 && months > 0)
      return `${years}лет ${remainingMonths}мес ${remainingDays}д ${remainingHours}ч ${remainingMinutes}мин`;

    if (remainingMonths > 0 && remainingDays > 0) {
      return `${remainingMonths}мес ${remainingDays}д ${remainingHours}ч ${remainingMinutes}мин`;
    }

    if (remainingDays === 0 && remainingMinutes <= 10 && remainingHours === 0)
      return `${remainingHours}ч ${remainingMinutes}мин ${remainingSeconds}сек`;

    return remainingDays > 0
      ? `${remainingDays}д ${remainingHours}ч ${remainingMinutes}мин`
      : `${remainingHours}ч ${remainingMinutes}мин`;
  }
}

export const getRemainingMinutes = (inputDate: string) => {
  const currentDate = new Date();

  const targetDate = new Date(inputDate);
  //const localOffsetMinutes = utcDate.getTimezoneOffset();
  //const localInputDate = new Date(utcDate.setMinutes(utcDate.getMinutes() - localOffsetMinutes));
  //const targetDate = new Date(localInputDate);

  const diffInMilliseconds = targetDate.getTime() - currentDate.getTime();
  const diffInMinutes = Math.floor(diffInMilliseconds / (1000 * 60));

  return diffInMinutes;
};
